/**
 * Block-IDs in diesem Array werden nicht im Blockly-Menü (Toolbox) angezeigt.
 * Die Blöcke bleiben registriert und können im Code-Editor verwendet werden,
 * tauchen aber nicht in der Kategorie-Auswahl auf.
 */
/* export const BLOCKLY_HIDDEN_BLOCKS: string[] = [
    'MY_START_BLOCK'
];


 */

export const BLOCKLY_HIDDEN_BLOCKS: string[] = [

];
